/* eslint-disable */

import * as React from 'react';
import PropTypes from 'prop-types';

const IconX = ({
    height = '32',
    width = '32',
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_236_824)">
            <path
                d="M25.3333 8.54666L23.4533 6.66666L16 14.12L8.54666 6.66666L6.66666 8.54666L14.12 16L6.66666 23.4533L8.54666 25.3333L16 17.88L23.4533 25.3333L25.3333 23.4533L17.88 16L25.3333 8.54666Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_236_824">
                <rect width="32" height="32" fill="currentColor" />
            </clipPath>
        </defs>
    </svg>
);

export default IconX;

IconX.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
};
